import React, { useMemo } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface BacktestChartProps {
  loading?: boolean;
}

const BacktestChart: React.FC<BacktestChartProps> = ({ loading }) => {
  if (loading) {
    return (
      <div className="h-48 flex items-center justify-center">
        <div className="animate-pulse bg-gradient-to-r from-slate-200 via-slate-300 to-slate-200 w-full h-full rounded-xl"></div>
      </div>
    );
  }

  const backtestData = useMemo(() => 
    Array.from({ length: 30 }, (_, i) => ({
      day: `Day ${i + 1}`,
      rmse: 2.5 + Math.sin(i * 0.2) * 0.5 + Math.random() * 0.3,
      mae: 1.8 + Math.sin(i * 0.15) * 0.4 + Math.random() * 0.2,
      mape: 5.2 + Math.sin(i * 0.1) * 1.0 + Math.random() * 0.5
    })), []);

  return (
    <div className="w-full h-48 bg-gradient-to-br from-slate-50 to-white rounded-xl border border-slate-200 p-4">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={backtestData}>
          <CartesianGrid strokeDasharray="2 2" stroke="#e2e8f0" opacity={0.3} />
          <XAxis 
            dataKey="day" 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 10, fill: '#64748b' }}
          />
          <YAxis 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#64748b' }}
          />
          <Tooltip />
          <Line type="monotone" dataKey="rmse" stroke="#ef4444" strokeWidth={2} dot={false} name="RMSE" />
          <Line type="monotone" dataKey="mae" stroke="#f59e0b" strokeWidth={2} dot={false} name="MAE" />
          <Line type="monotone" dataKey="mape" stroke="#6366f1" strokeWidth={2} dot={false} name="MAPE" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BacktestChart;